import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as FormActionSvg } from '../../../../assets/icons/form-action.svg';
import { ReactComponent as LocationSvg } from '../../../../assets/icons/location.svg';
import { ReactComponent as LocationGreySvg } from '../../../../assets/icons/location-grey.svg';
import { Button, ConfigProvider, Flex, Typography } from 'antd';
import { HYPHEN, PAGE_KEYS } from '../../../../utilities/constants';
import { UserRolesAndPermissionsContext } from '../../../../context/UserRolesAndPermissionsContext';

const { Text } = Typography;
const InProgressSOSCard = ({
  data,
  handleSoResolutionModalOpen,
  onTripDetailClick,
}) => {
  const { isViewOnly } = useContext(UserRolesAndPermissionsContext);
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Flex vertical gap={12}>
        <Text strong>
          {data?.trip_id || HYPHEN} | {data?.device_id || HYPHEN}
        </Text>
        <Text>Reported By: {data?.reporter}</Text>
        <Text>
          Unresolved For:{' '}
          <Text type="danger">{data?.unresolvedFor || HYPHEN}</Text>
        </Text>
        <div></div>
        <Flex gap={24} justify="flex-end">
          <Button
            className="sos-card-action-button"
            icon={data?.trip_id ? <LocationSvg /> : <LocationGreySvg />}
            onClick={() =>
              onTripDetailClick(
                data,
                data?.trip_id,
                data?.device_id,
                data?.anomaly_id
              )
            }
            disabled={!data?.trip_id}
          />
          {!isViewOnly(PAGE_KEYS.SAFETY_AND_ANOMALY_MONITORING) && (
            <Button
              className="sos-card-action-button"
              icon={<FormActionSvg />}
              type="primary"
              onClick={() => handleSoResolutionModalOpen(data)}
            />
          )}
        </Flex>
      </Flex>
    </ConfigProvider>
  );
};

InProgressSOSCard.propTypes = {
  data: PropTypes.shape({
    trip_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    device_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reporter: PropTypes.string,
    unresolvedFor: PropTypes.string,
    anomaly_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  handleSoResolutionModalOpen: PropTypes.func.isRequired,
  onTripDetailClick: PropTypes.func.isRequired,
};

export default React.memo(InProgressSOSCard);
